import React from "react";
import "./Testimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { Pagination } from "swiper";
import "swiper/css/pagination";

import profilePic1 from "../../img/profile1.png";
import profilePic2 from "../../img/profile2.png";
import profilePic3 from "../../img/profile3.png";
import profilePic4 from "../../img/profile4.png"; 

const Testimonial = () => {
  const clients = [
    {
      img: profilePic1,
      review:
        "Improve my skills in programming and development. Always trying to get better in every aspect",
    },
    {
      img: profilePic2,
      review:
        "Work in large projects and build an extensive career",
    },
    {
      img: profilePic3,
      review:
        "Carry out tasks that allow me, in the future, to create my own company",
    },
    {
      img: profilePic4,
      review:
        "Share activities with a team and develop a better integration capacity",
    },
  ];

  return (
    <div className="t-wrapper" id="testimonial">
      <div className="t-heading">
        <span>Setting my goals </span>
        <span>to reach what </span>
        <span>I am capable of</span>
      <div className="blur t-blur1" style={{ background: "var(--purple)" }}></div>
      <div className="blur t-blur2" style={{ background: "skyblue" }}></div>

      </div>
      <Swiper
        // install Swiper modules
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {clients.map((client, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="testimonial">
                <img src={client.img} alt="" />
                <span>{client.review}</span>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Testimonial;
